import React, { Fragment, useContext, useState } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { AuthContext } from '../context/auth';
import { Button, Modal, Form } from 'semantic-ui-react';
import { useForm, useDeletePasswordForm } from '../utils/hooks';
import gql from 'graphql-tag';

const Profile = () => {
  const context = useContext(AuthContext);
  const [openChangePasswordModal, setChangePasswordModal] = useState(false);
  const [openDeleteUserModal, setDeleteUserModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [errors2, setErrors2] = useState({});
  const { onChange, onSubmit, values } = useForm(changePassword, {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });

  const { onChange2, onSubmit2, values2 } = useDeletePasswordForm(deleteUser, {
    confirmDeletePassword: '',
  });

  const [changeUserPassword, { loading }] = useMutation(CHANGE_PASSWORD, {
    update(proxy) {
      context.logout();
      window.location.reload(false);
    },
    onError(err) {
      console.log(err);
      setErrors(err.graphQLErrors[0].extensions.exception.errors);
    },
    variables: {
      username: context.user.username,
      password: values.currentPassword,
      newPassword: values.newPassword,
      confirmNewPassword: values.confirmNewPassword,
    },
  });

  const [deleteCurrentUser, MutationResult] = useMutation(DELETE_USER, {
    update(proxy) {
      context.logout();
      window.location.reload(false);
    },
    onError(err) {
      console.log(err);
      setErrors2(err.graphQLErrors[0].extensions.exception.errors);
    },
    variables: {
      username: context.user.username,
      password: values2.confirmDeletePassword,
    },
  });

  function changePassword() {
    changeUserPassword();
  }

  function deleteUser() {
    deleteCurrentUser();
  }

  return (
    <Fragment>
      <h1>My Details</h1>
      <p>Username: {context.user.username}</p>
      <p>Firstname: {context.user.firstName}</p>
      <p>Lastname: {context.user.lastName}</p>
      <p>Email: {context.user.email}</p>
      <Modal
        id="change_password_modal"
        open={openChangePasswordModal}
        onClose={() => setChangePasswordModal(false)}
        onOpen={() => {
          setChangePasswordModal(true);
        }}
        trigger={<button class="link-button">Change Password</button>}
      >
        <Modal.Header className="btn">Change Password</Modal.Header>
        <Modal.Content>
          <Form noValidate className={loading ? 'loading' : ''}>
            <Form.Input
              label="Crrent Password"
              type="password"
              id="current_password_input"
              placeholder="Enter current password ..."
              name="currentPassword"
              value={values.currentPassword}
              error={errors.password ? true : false}
              onChange={onChange}
            />
            <Form.Input
              label="New Password"
              type="password"
              id="new_password_input"
              placeholder="Enter new password ..."
              name="newPassword"
              value={values.newPassword}
              error={errors.newPassword ? true : false}
              onChange={onChange}
            />
            <Form.Input
              label="Confirm New Password"
              type="password"
              id="confirm_new_password_input"
              placeholder="Confirm new password ..."
              name="confirmNewPassword"
              value={values.confirmNewPassword}
              error={errors.confirmNewPassword ? true : false}
              onChange={onChange}
            />
          </Form>
          {Object.keys(errors).length > 0 && (
            <div className="ui error message">
              <ul className="list">
                {Object.values(errors).map((val) => (
                  <li key={val}>{val}</li>
                ))}
              </ul>
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button
            id="changePasswordNo"
            color="black"
            onClick={() => setChangePasswordModal(false)}
          >
            Cancel
          </Button>
          <Button
            id="changePasswordYes"
            onClick={(event) => {
              onSubmit(event);
            }}
            color="teal"
          >
            Confirm
          </Button>
        </Modal.Actions>
      </Modal>
      <p />
      <Modal
        id="delete_user_modal"
        open={openDeleteUserModal}
        onClose={() => setDeleteUserModal(false)}
        onOpen={() => {
          setDeleteUserModal(true);
        }}
        trigger={
          <button class="link-button link-button-warning">
            Delete Account
          </button>
        }
      >
        <Modal.Header>Delete Account</Modal.Header>
        <Modal.Content>
          Are you sure you would like to delete your account? <br />
          <b>Warning: This action can not be reversed!</b>
          <p />
          <Form noValidate className={MutationResult.loading ? 'loading' : ''}>
            <Form.Input
              label="Password"
              type="password"
              id="confirm_delete_password_input"
              placeholder="Enter password ..."
              name="confirmDeletePassword"
              value={values2.confirmDeletePassword}
              error={errors2.password ? true : false}
              onChange={onChange2}
            />
          </Form>
          {Object.keys(errors2).length > 0 && (
            <div className="ui error message">
              <ul className="list">
                {Object.values(errors2).map((val) => (
                  <li key={val}>{val}</li>
                ))}
              </ul>
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button
            id="deleteUserNo"
            color="black"
            onClick={() => setDeleteUserModal(false)}
          >
            Cancel
          </Button>
          <Button
            id="deleteUserYes"
            onClick={(event) => {
              onSubmit2(event);
            }}
            color="red"
          >
            Confirm
          </Button>
        </Modal.Actions>
      </Modal>
    </Fragment>
  );
};

const CHANGE_PASSWORD = gql`
  mutation changePassword(
    $username: String!
    $password: String!
    $newPassword: String!
    $confirmNewPassword: String!
  ) {
    changePassword(
      username: $username
      password: $password
      newPassword: $newPassword
      confirmNewPassword: $confirmNewPassword
    ) {
      username
      password
    }
  }
`;

const DELETE_USER = gql`
  mutation deleteUser($username: String!, $password: String!) {
    deleteUser(username: $username, password: $password)
  }
`;

export default Profile;
